export default __webpack_public_path__ + "static/study-cafe4-5cf630d8d05a4a2d35d90a568706b3db.jpg";